import { apiClient } from "./client";
import type {
  CfoActionAnswer,
  CfoActionAnswerRead,
  CfoActionList,
  CfoPlaceSuggestion,
} from "./types";

const base = (slug: string, companyId: number) =>
  `/projects/${encodeURIComponent(slug)}/cfo-workflow/companies/${companyId}/actions`;

export async function getCfoActions(slug: string, companyId: number): Promise<CfoActionList> {
  return (await apiClient.get<CfoActionList>(base(slug, companyId))).data;
}

export async function answerCfoAction(
  slug: string,
  companyId: number,
  request: CfoActionAnswer,
): Promise<CfoActionAnswerRead> {
  return (await apiClient.post<CfoActionAnswerRead>(`${base(slug, companyId)}/answers`, request)).data;
}

/** A country suggested for a place question from the place label alone. */
export async function suggestCfoPlaceCountry(
  slug: string,
  companyId: number,
  actionId: string,
): Promise<CfoPlaceSuggestion> {
  return (
    await apiClient.post<CfoPlaceSuggestion>(`${base(slug, companyId)}/suggestion`, {
      action_id: actionId,
    })
  ).data;
}
